'use client'
import { useState } from 'react';
import { motion } from 'framer-motion';
import s from './columns.module.scss';
import ProjectFeaturedComponent from '@/components/singles/projectFeatured';
import { Status, Region, Typology } from '@/types/singles/category';
import { Image } from '@/types/common/ImageData';
import JournalFeaturedComponent from '@/components/singles/journalFeatured';

interface ColumnsProps {
    data: any;
}

export default function Columns({ data }: ColumnsProps) {
    return (
        <>
        {data.option == 'journal' && (
            <div className={s[`columns${data.columns}`]}>
                {data.journals.map((journal: any, index: any) => (
                    <motion.div  
                    className={s.column} 
                    key={`journal-${index}`}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}>
                        <JournalFeaturedComponent data={journal} full={data.columns == '1'}/>
                    </motion.div>
                ))}
            </div>
        )}
        {data.option == 'project' && (
            <div className={s[`columns${data.columns}`]}>
                {data.projects.map((project: any, index: any) => (
                    <motion.div  
                    className={s.column} 
                    key={`project-${index}`}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}>
                        <ProjectFeaturedComponent data={project} full={data.columns == '1'}/>
                    </motion.div>
                ))}
            </div>
        )}
        </>
    );
}